export enum PresenceMonitorState {
    UNKNOWN = -1,
    NOT_AUTHORIZED = 0,
    AUTHORIZED = 1,
    NEEDS_UPDATE = 2,
    SUBSCRIBED = 3,
    INVALID = 4 // this might be temporary while things are being sorted out
}

export const PresenceUpdateReason = {
    CONNECTION_ID_CHANGE: 'CONNECTION_ID_CHANGE',
    MS_GRAPH_CONNECTOR_CHANGE: 'MS_GRAPH_CONNECTOR_CHANGE',
    DISABLE_FEATURE: 'DISABLE_FEATURE',
    REFRESH: 'REFRESH',
    RESET_SUBSCRIPTIONS: 'RESET_SUBSCRIPTIONS'
}

export interface PresenceMonitor {
    monitorId: string;
    connectionId: string;
    status: PresenceMonitorState;
    userCount?: number;
};

export enum MSTeamsTaskState {
    NOT_STARTED = 0,
    EXECUTING,
    FINISHED_SUCCESS,
    FINISHED_CAUTION,
    FINISHED_FAILURE
}
export interface MSTeamsVerifyTask {
    displayStringKey: string;
    state: MSTeamsTaskState;
    errorStringKey?: string;
    actionStringKey?: string;
}

export interface MSTeamsVerifyTaskSet {
  displayStringKey?: string;
  tasks: Map<string, MSTeamsVerifyTask>
}

export const InitBaseVerifyTaskList: Map<string, MSTeamsVerifyTask> = new Map([
  ['initVerifyData', {
    displayStringKey: 'integrations.msteams.verify-dialog.system-config.tasks.init-verify-data',
    state: MSTeamsTaskState.NOT_STARTED
  }],
]);

export const MSTeamsIntegrationBaseVerifyTaskList: Map<string, MSTeamsVerifyTask> = new Map([
  ['clientSecret', {
    displayStringKey: 'integrations.msteams.verify-dialog.system-config.tasks.verify-client-secret-expired',
    state: MSTeamsTaskState.NOT_STARTED,
  }],
  ['connectorStatus', {
    displayStringKey: 'integrations.msteams.verify-dialog.system-config.tasks.verify-main-connector-status',
    state: MSTeamsTaskState.NOT_STARTED,
  }],
  ['cloudlinkToMSTeamsConnectorPermissions', {
    displayStringKey: 'integrations.msteams.verify-dialog.system-config.tasks.verify-cloudlink-to-msteams-permissions',
    state: MSTeamsTaskState.NOT_STARTED,
  }],
  ['msteamsToCloudlinkConnectorPermissions', {
    displayStringKey: 'integrations.msteams.verify-dialog.system-config.tasks.verify-msteams-to-cloudlink-permissions',
    state: MSTeamsTaskState.NOT_STARTED,
  }]
]);

export const CloudLinkToMSTeamsBaseVerifyTaskList: Map<string, MSTeamsVerifyTask> = new Map([
  ['cloudlinkToMSTeamsOn', {
    displayStringKey: 'integrations.msteams.verify-dialog.system-config.tasks.verify-cloudLink-to-msteams-on',
    state: MSTeamsTaskState.NOT_STARTED,
  }],
  ['cloudlinkToMSTeamsConnectorPermissions', {
    displayStringKey: 'integrations.msteams.verify-dialog.system-config.tasks.verify-cloudlink-to-msteams-permissions',
    state: MSTeamsTaskState.NOT_STARTED,
  }]
]);

export const MSTeamsToCloudLinkBaseVerifyTaskList: Map<string, MSTeamsVerifyTask> = new Map([
  ['pbxOnboarded', {
    displayStringKey: 'integrations.msteams.verify-dialog.system-config.tasks.verify-pbx-onboarded',
    state: MSTeamsTaskState.NOT_STARTED,
  }],
  ['micollabConfigured', {
    displayStringKey: 'integrations.msteams.verify-dialog.system-config.tasks.verify-micollab-configured-in-gw',
    state: MSTeamsTaskState.NOT_STARTED,
  }],
  ['msteamIntegrationExists',{
    displayStringKey: 'integrations.msteams.verify-dialog.system-config.tasks.verify-msteams-integration-exists-on-micollab',
    state: MSTeamsTaskState.NOT_STARTED,
  }],
  ['msTeamsIntegrationEnabled', {
    displayStringKey: 'integrations.msteams.verify-dialog.system-config.tasks.verify-msteams-integration-enabled-on-micollab',
    state: MSTeamsTaskState.NOT_STARTED,
  }],
  ['msteamsToCloudlinkConnectorPermissions', {
    displayStringKey: 'integrations.msteams.verify-dialog.system-config.tasks.verify-msteams-to-cloudlink-permissions',
    state: MSTeamsTaskState.NOT_STARTED,
  }],
  ['msTeamsToCloudLinkOn', {
    displayStringKey: 'integrations.msteams.verify-dialog.system-config.tasks.verify-msteams-to-cloudLink-on',
    state: MSTeamsTaskState.NOT_STARTED,
  }],
  ['msTeamsToCloudLinkEnoughMonitors', {
    displayStringKey: 'integrations.msteams.verify-dialog.system-config.tasks.verify-msteams-to-cloudLink-enough-monitors',
    state: MSTeamsTaskState.NOT_STARTED,
  }],
  ['msTeamsToCloudLinkMonitorsInError', {
    displayStringKey: 'integrations.msteams.verify-dialog.system-config.tasks.verify-msteams-to-cloudLink-monitor-health',
    state: MSTeamsTaskState.NOT_STARTED,
  }],
  ['msTeamsToCloudLinkAllUsersSubscribed', {
    displayStringKey: 'integrations.msteams.verify-dialog.system-config.tasks.verify-msteams-to-cloudLink-subscribed-users',
    state: MSTeamsTaskState.NOT_STARTED,
  }],
  // keeping for now, not sure if it is required yet
  // ['bidirectionalSolutionValidation', {
  //   displayStringKey: 'integrations.msteams.verify-dialog.system-config.tasks.verify-bidirectional-solution-validation',
  //   state: MSTeamsTaskState.NOT_STARTED,
  // }]
]);

export enum VERIFY_SET_ID  {
  INIT = 0,
  MSTEAMS_INTEGRATION = 1,
  CLOUDLINK_TO_MSTEAMS = 2,
  MSTEAMS_TO_CLOUDLINK
}

export const VerifyTaskSets: MSTeamsVerifyTaskSet[] = [
  {
    tasks: new Map(InitBaseVerifyTaskList)
  },
  {
    displayStringKey: 'integrations.msteams.verify-dialog.system-config.sets.set-microsoft-teams-integration',
    tasks: new Map(MSTeamsIntegrationBaseVerifyTaskList)
  },
  {
    displayStringKey: 'integrations.msteams.verify-dialog.system-config.sets.set-cloudlink-to-msteams',
    tasks: new Map(CloudLinkToMSTeamsBaseVerifyTaskList)
  },
  {
    displayStringKey: 'integrations.msteams.verify-dialog.system-config.sets.set-msteams-to-cloudlink',
    tasks: new Map(MSTeamsToCloudLinkBaseVerifyTaskList)
  }
]

interface IPresenceWorkflow {
    readonly name: string;
    readonly flowId: string;
}

export const MSTeamsWorkflows = {
        micollabPresenceToMSTeams: 
        {
            name: 'MS Teams Presence Cloned',
            flowId: 'global_f58adcec-0184-4526-9e95-47c51cb1df13'
        },
        aggregatePresenceToMSTeams: 
        {
            name: 'Filtered Aggregate Presence source changed global',
            flowId: 'global_07d4fa68-3860-4891-bfc9-2695254d0e0f'
        },
        msGraphPresenceChange: 
        {
            name: 'MS Graph Presence Change Cloned',
            flowId: 'global_333ccc91-94aa-4e77-a307-6075cf0542b5'
        },
        msTeamsPresenceToMitelPBXUserChange: 
        {
            name: 'MS Teams Presence to Mitel PBX User Change Cloned',
            flowId: 'global_26dd714c-86ab-46f1-b6ad-ba0baaace49a'
        },
        msTeamsPresenceToMitelPBXScheduler: 
        {
            name: 'MS Teams Presence to Mitel PBX User Scheduler Cloned',
            flowId: 'global_40d949d0-5c45-4144-bc45-6bb2260c5282'
        }, 
        msTeamsPresenceToMitelPBXValidateConnections:
        {
            name: 'MS Teams Presence to Mitel PBX Validate Connections Cloned',
            flowId: 'global_7a5dbd01-fd45-45ce-afdf-1fbd9ca56808'
        }, 
        updateMiCollabPresenceStatus:
        {
            name: 'Update MiCollab Presence Status Cloned',
            flowId: 'global_b3a15549-4e91-4e6b-acd9-234c38491bc0'
        },
        clientSecretWorkflow:
        {
            name: "Query the client secret based on connector name",
            flowId: 'global_a217a22c-d9dc-40df-aeeb-ebd4148642d2'
        },
        connectorPermissionWorkflow:
        {
            name: "Validator connector permissions",
            flowId: "global_f240b0c0-9250-4e16-9b5e-3687eeb7e0fd"
        },
        biDirectionalSolutionWorkflow:
        {
            name: "Bidirectional Solution validation",
            flowId: "global_99b395a3-a955-4ebc-aea2-f4b316963b52"
        },
        getUserPresence:
        {
          name: "Get User Presence Data",
          flowId: "global_eddabb24-eef4-4c88-9241-8bb9d4ba8288"
        },
        syncUserMiCollabPresenceToMSTeams:
        {
          name: "Sync User MiCollab Presence to MS Teams",
          flowId: "global_9aebc251-2d0d-4f89-aa31-58a599b393f0"
        },
        clearStuckCalls:
        {
          name: "Clear a user's stuck calls",
          flowId: "global_7d18b590-88f7-43d8-a841-92d0bd6b4f36"
        },
        featureUpdatePending:
        {
          name: "Feature update pending",
          flowId: "global_ad88e0d8-133b-4efe-8749-4f279145f3a7"
        }
    };

